import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { fullName } from "@/lib/crm";

export default function RecipientPicker({ contacts, value, onChange }) {
  const tags = [...new Set(contacts.flatMap((c) => c.tags))];
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-1.5">
        <Button type="button" size="sm" variant="outline" className="h-7 text-xs" onClick={() => onChange(contacts.map((c) => c.id))} data-testid="recipients-select-all">All</Button>
        <Button type="button" size="sm" variant="outline" className="h-7 text-xs" onClick={() => onChange([])} data-testid="recipients-clear">Clear</Button>
        {tags.map((t) => (
          <Button key={t} type="button" size="sm" variant="outline" className="h-7 text-xs border-[#D4AF37]/50"
            onClick={() => onChange([...new Set([...value, ...contacts.filter((c) => c.tags.includes(t)).map((c) => c.id)])])}
            data-testid={`recipients-tag-${t}`}>+ {t}</Button>
        ))}
      </div>
      <div className="max-h-48 overflow-y-auto rounded-lg border divide-y">
        {contacts.map((c) => (
          <label key={c.id} className="flex items-center gap-3 p-2 text-sm cursor-pointer hover:bg-[#FFFDF0]">
            <Checkbox checked={value.includes(c.id)} onCheckedChange={() => toggle(c.id)} data-testid={`recipient-${c.id}`} />
            <span className="font-medium">{fullName(c)}</span>
            <span className="text-xs text-stone-500 truncate">{c.email}</span>
          </label>
        ))}
      </div>
      <div className="text-xs text-stone-500" data-testid="recipients-count">{value.length} recipients selected</div>
    </div>
  );
}
